export const usersnapFeedback = (apiKey, store) => {
  window.onUsersnapCXLoad = api => {
    api.on('open', event => {
      const {
        auth: { currentUser }
      } = store.getState();
      const { email } = currentUser;
      if (email) {
        event.api.setValue('visitor', email);
      }
    });
    api.init();
  };
  const script = document.createElement('script');
  script.async = 1;
  script.src = `https://widget.usersnap.com/load/${apiKey}?onload=onUsersnapCXLoad`;
  document.getElementsByTagName('head')[0].appendChild(script);
};

export const usersnapSurveyInit = (apiKey, onSubmitOrDismiss) => {
  const onEvent = event => {
    const eventType = event.type === 'submit' && event?.values.confirmation ? 'submit' : 'dismiss';
    onSubmitOrDismiss(eventType);
  };
  window.onUsersnapCXLoadSurvey = function(api) {
    api.init({
      button: { isHidden: true }
    });
    api.on('submit', onEvent);
    api.on('close', onEvent);
    window.UsersnapSurvey = api;
  };
  const script = document.createElement('script');
  script.async = 1;
  script.src = `https://widget.usersnap.com/load/${apiKey}?onload=onUsersnapCXLoadSurvey`;
  document.getElementsByTagName('head')[0].appendChild(script);
};

export const usersnapSurveyOpen = () => {
  window.UsersnapSurvey?.open();
};
